import axios from "axios";
import store from "../store";

// Add details into session table
export async function AddSessionInfo() {
  const userAgent = navigator.userAgent;
  let browserName = "Unknown Browser";
  let version = "Unknown Version";

  // Chrome
  if (
    userAgent.includes("Chrome") &&
    !userAgent.includes("Edg") &&
    !userAgent.includes("OPR")
  ) {
    browserName = "Chrome";
    const match = userAgent.match(/Chrome\/(\d+\.\d+\.\d+\.\d+)/);
    version = match ? match[1] : "Unknown Version";
  }
  // Firefox
  else if (userAgent.includes("Firefox")) {
    browserName = "Firefox";
    const match = userAgent.match(/Firefox\/(\d+\.\d+)/);
    version = match ? match[1] : "Unknown Version";
  }
  // Safari
  else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
    browserName = "Safari";
    const match = userAgent.match(/Version\/(\d+\.\d+\.\d+)/);
    version = match ? match[1] : "Unknown Version";
  }
  // Edge
  else if (userAgent.includes("Edg")) {
    browserName = "Edge";
    const match = userAgent.match(/Edg\/(\d+\.\d+\.\d+\.\d+)/);
    version = match ? match[1] : "Unknown Version";
  }
  // Internet Explorer
  else if (userAgent.includes("MSIE") || userAgent.includes("Trident")) {
    browserName = "Internet Explorer";
    const match = userAgent.match(/(MSIE\s|rv:)(\d+\.\d+)/);
    version = match ? match[2] : "Unknown Version";
  }

  // Operating system
  let os = "Unknown OS";
  if (userAgent.includes("Win")) os = "Windows";
  else if (userAgent.includes("Mac")) os = "macOS";
  else if (userAgent.includes("X11") || userAgent.includes("Linux"))
    os = "Linux";
  else if (userAgent.includes("Android")) os = "Android";
  else if (userAgent.includes("like Mac")) os = "iOS";

  // Device type
  let deviceType = "Unknown";
  if (/Mobile|Android|iPhone|iPad|iPod/i.test(userAgent)) {
    deviceType = /iPad/i.test(userAgent) ? "Tablet" : "Mobile";
  } else {
    deviceType = "Desktop";
  }

  // Screen resolution
  const screenResolution = `${window.screen.width}x${window.screen.height}`;

  // Language
  const primaryLanguage =
    navigator.language || navigator.userLanguage || "Unknown";

  // Referrer
  var referrerURL;
  var url_ = window.location.href.toLowerCase();
  if (url_.indexOf("bastest") > -1) {
    referrerURL = "https://www.temp.bastest.com/make_payment/index.html";
  } else if (url_.indexOf("myenroll") > -1) {
    referrerURL = "https://www.bas1.myenroll.com/make_payment/index.html";
  } else if (url_.indexOf("localhost") > -1) {
    referrerURL = "https://www.localhost.com/make_payment/index.html";
  }

  // Time zone
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Connection type
  let connectionType = "Unknown";
  if ("connection" in navigator) {
    const effectiveType = navigator.connection?.effectiveType || "";
    switch (effectiveType) {
      case "wifi":
        connectionType = "WiFi";
        break;
      case "ethernet":
        connectionType = "Ethernet";
        break;
      case "cellular":
        connectionType = "Cellular (Mobile)";
        break;
      case "slow-2g":
      case "2g":
        connectionType = "2G";
        break;
      case "3g":
        connectionType = "3G";
        break;
      case "4g":
        connectionType = "4G";
        break;
      default:
        connectionType = effectiveType || "Unknown";
    }
  }

  // Page views
  let pageView = "No page views recorded.";
  const pageViews = localStorage.getItem("pageViews");
  if (pageViews !== null && !isNaN(parseInt(pageViews))) {
    pageView = parseInt(pageViews);
  }

  // IP address
  let ipAddress = await getUserIP(); // get the ip from server side
  const methodUrl_ = store.state.methodurlvalue;
  //console.log("methodUrl_ " + methodUrl_);

  var emp_ =
    store.state.employee_number == "" ? 0 : store.state.employee_number;

  // Send session info
  try {
    await axios.post(
      methodUrl_ + "/ee_signup_newhire_temps/WebService.asmx/AddSessionInfo",
      {
        ref_rec_id_: emp_,
        ip_address: ipAddress,
        user_agent_string: userAgent,
        browser_type: browserName,
        browser_version: version,
        operating_system: os,
        device_type: deviceType,
        screen_resolution: screenResolution,
        language_preferences: primaryLanguage,
        referrer_url: referrerURL,
        time_zone: timeZone,
        connection_type: connectionType,
        page_views: pageView,
        appid: 0,
      },
    );

    //store.state.session_record_id = res.data.d;
    //store.state.savedsession = "1";
    //console.log("Session saved:", res.data.d);
  } catch (error) {
    console.error("Session save failed:", error);
    //store.state.savedsession = "";
  }
}
//get the user ipa ddress
export async function getUserIP() {
  try {
    // Use a public API to get the user's IP address
    const response = await fetch("https://api.ipify.org?format=json");
    const data = await response.json();
    //console.log("ip " + data.ip);
    return data.ip; // Return the IP address
  } catch (error) {
    return null; // Return null in case of error
  }
}

//Page View
export function trackPageViews() {
  let pageViews = localStorage.getItem("pageViews");

  if (pageViews == null) {
    pageViews = 0;
  } else {
    pageViews = parseInt(pageViews);
  }
  pageViews += 1;
  //console.log("pageViews", store.state.methodurlvalue);
  localStorage.setItem("pageViews", pageViews);
}
// checks if the last access time is more than 10 minutes ago
export async function checkLastAccessTimeUI(accessTime) {
  if (!accessTime) return 0;

  const lastAccess = new Date(accessTime);
  const now = new Date();

  if (isNaN(lastAccess.getTime())) {
    console.log("Invalid accessTime format:", accessTime);
    return 0;
  }

  const diffInMinutes = (now - lastAccess) / (1000 * 60);
  // console.log("Last access was", diffInMinutes.toFixed(2), "minutes ago");

  return diffInMinutes > 5 ? 1 : 0;
}

// Retrieves session details from the server and validates the IP and time
export async function Get_tmp_ipsession_details() {
  //console.log("Checking session:", store.state.session_record_id);

  const url_ =
    store.state.methodurlvalue +
    "/ee_signup_newhire_temps/WebService.asmx/Get_tmp_ipsession_details";

  const ipAddress = await getUserIP();
  const tempee_id = store.state.temp_emp_no;
  const sess_id = store.state.session_record_id;

  if (!tempee_id || !sess_id) {
    console.warn("Missing employee ID or session ID.");
    return "";
  }

  try {
    const response = await axios.post(url_, {
      ref_rec_id: tempee_id,
      rec_id: sess_id,
    });

    const result = JSON.parse(response.data.d);
    // console.log("session details " + JSON.stringify(result));
    if (!Array.isArray(result) || result.length === 0) {
      console.warn("No session data returned.");
      return "";
    }

    const { ACCESS_TIME: accessTime, IP_ADDRESS: sessionIP } = result[0];

    store.state.session_accesstime = accessTime;

    const checktime_ = await checkLastAccessTimeUI(accessTime);
    //console.log("checktime_ " + checktime_);
    if (ipAddress === sessionIP && checktime_ === 0) {
      return "1"; // Valid session
    } else {
      alert("Session expired");
      store.state.currentform = 1;
      //this.$forceUpdate();

      return "0"; // Different IP or expired
    }
  } catch (error) {
    console.error("Error fetching session details:", error);
    return "";
  }
}

//check ipaddress-not used
// export async function checkIPaddress() {
//   let ipAddress = await getUserIP();
//   if (ipAddress == store.state.session_ipaddress) {
//     return "1";
//   } else {
//     return "0";
//   }
// }

//Check session is is valid - ValidTempSessionID
export async function ValidTempSessionID() {
  var url_ =
    store.state.methodurlvalue +
    "/ee_signup_newhire_temps/WebService.asmx/ValidTempSessionID";
  let ipAddress = await getUserIP();

  try {
    const response = await axios.post(url_, {
      ip_address: ipAddress,
      ref_rec_id_: store.state.temp_emp_no,
    });
    //console.log("last acces time " + response.data.d);
    var res = response.data.d;
    return res;
  } catch (error) {
    console.error("Error checking last access time:", error);
    return "";
  }
}
 export async function   redirecthome() {
      // window.location = this.$store.state.myenroll_url;
      const href = location.href.toLowerCase();
      if (href.indexOf("test") > -1) {
        window.location =
          "https://www.bastest.com/web_projects/MainHomePage/Login.aspx";
      } else {
        window.location = store.state.myenroll_url;
      }
    }